import React, { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { Redirect, Route } from "react-router-dom";
import { USER_ROLES } from "../Constants";

export const VSourceAdminRoute = (props) => {
    const { component: Component, ...rest } = props;
    const { context, userHavePermission } = useContext(AuthContext);

    const isVSourceAdminUser = userHavePermission(
        { user: context.user },
        USER_ROLES.VSOURCE_VENDEX_USER
    );

    return (
        <Route
            {...rest}
            render={(props) =>
                isVSourceAdminUser ? (
                    <Component {...props} {...rest} />
                ) : (
                    <Redirect
                        to={{
                            pathname: "/vsource/vendors",
                            state: { from: props.location },
                        }}
                    />
                )
            }
        />
    );
};
